import React from "react";
import { tokens } from "../../theme";

const sc = (value) => `${Number(value).toLocaleString("en-US", { maximumFractionDigits: 2 })} SC`;
const asDate = (value) =>
  new Date(value).toLocaleString("en-US", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });
const filled = (value) => value !== "" && value !== null && value !== undefined;

/**
 * Reads the form back in plain sentences, so the admin can check what players will get
 * before saving. Only says something about a setting once it is filled in.
 */
const TournamentSummary = ({ form, prizeRows }) => {
  const lines = [];
  const pool = parseFloat(form.prizePool);
  const winners = parseInt(form.winnerCount, 10);
  // A fixed pool ignores any % typed earlier.
  const growth = form.poolType === "DYNAMIC" ? parseFloat(form.poolGrowthPercent) : NaN;
  const tiers = form.poolTiers.filter((t) => filled(t.minPlayers) && filled(t.pool));
  const poolCanChange = growth > 0 || tiers.length > 0 || filled(form.winnerPercent);

  if (form.startDate && form.endDate) {
    lines.push(`Runs from ${asDate(form.startDate)} to ${asDate(form.endDate)} (your local time).`);
  }
  if (form.winMechanic) {
    const scoreWord = form.winMechanic === "Total Bet" ? "bet" : "won";
    lines.push(
      `Players press Join, then play the tournament games with Sweeps Coins. Their score is the total SC they ${scoreWord} after joining.`
    );
  }
  if (filled(form.minBet) && parseFloat(form.minBet) > 0) {
    lines.push(`Spins with a bet below ${sc(form.minBet)} do not count.`);
  }
  if (pool > 0 && winners > 0) {
    lines.push(
      poolCanChange
        ? `The top ${winners} players share up to ${sc(pool)}.`
        : `The top ${winners} players share ${sc(pool)}.`
    );
  }
  if (prizeRows.length > 0) {
    const top = prizeRows.slice(0, 3).map((row) => `#${row.rank} ${sc(row.prize)}`);
    lines.push(`At the ${growth > 0 ? "maximum" : "full"} pool: ${top.join(", ")}${prizeRows.length > 3 ? ", ..." : ""}`);
  }
  if (growth > 0) {
    lines.push(
      `The pool starts at 0 and is ${growth}% of all counted bets so far. For example, if players bet ${sc(50000)} in total, the pool is ${sc(
        (50000 * growth) / 100
      )}${pool > 0 ? ` (never more than ${sc(pool)})` : ""}.`
    );
  }
  if (tiers.length > 0) {
    const steps = [...tiers]
      .sort((a, b) => a.minPlayers - b.minPlayers)
      .map((t) => `${t.minPlayers}+ players: ${sc(t.pool)}`);
    lines.push(`Pool by number of players: ${steps.join(", ")}.`);
  }
  if (filled(form.winnerPercent)) {
    lines.push(`Only ${form.winnerPercent}% of the players who qualify win (at least 1, at most ${winners || "-"}).`);
  }
  if (parseFloat(form.minTotalBet) > 0) {
    lines.push(`A player must bet at least ${sc(form.minTotalBet)} in total to win a prize.`);
  }
  if (filled(form.maxPrizeMultiplier)) {
    lines.push(`Nobody wins more than ${form.maxPrizeMultiplier}× what they bet in the tournament.`);
  }
  if (pool > 0 && winners > 0) {
    lines.push("When it ends, results are saved automatically and prizes are paid to the winners automatically.");
  }
  lines.push(
    form.isActive
      ? "Players see it once you add at least one active game (🎮 button in the list after saving)."
      : "Hidden from players: Active is switched off."
  );

  return (
    <div
      style={{
        marginTop: "24px",
        padding: "14px 16px",
        background: tokens.surface2,
        border: `1px solid ${tokens.border}`,
        borderRadius: "8px",
      }}
    >
      <div style={{ fontWeight: 700, color: tokens.text, marginBottom: "6px" }}>Summary: what players get</div>
      <ul style={{ margin: 0, paddingLeft: "18px", fontSize: "13px", color: tokens.text, lineHeight: 1.6 }}>
        {lines.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </div>
  );
};

export default TournamentSummary;
